import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactLoading from 'react-loading';

export default class Loader extends Component {
  static propTypes = {
    type: PropTypes.string,
    color: PropTypes.string,
    delay: PropTypes.number,
    height: PropTypes.oneOfType([ PropTypes.string, PropTypes.number]),
    width: PropTypes.oneOfType([ PropTypes.string, PropTypes.number]),
    className: PropTypes.string
  };

  render() {
    return (
      <div className="common-loader">
        <ReactLoading type='spinningBubbles' color="#112E51" {...this.props} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/common/Loader.js